import { render } from "./DashboardHeader.vue?vue&type=template&id=4e55979d"
import script from "./DashboardHeader.vue?vue&type=script&lang=js"
export * from "./DashboardHeader.vue?vue&type=script&lang=js"

import "./DashboardHeader.vue?vue&type=style&index=0&id=4e55979d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__